import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[decimalNotAllowed]',
})
export class DecimalNotAllowedDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '.') {
      event.preventDefault();
    }
  }
}
